/**
 * @description Gestion des fontions communes aux pages du site
 */

/* global bsBreakpoints */

(() => {
	// FONCTIONS
	// Savoir quand la page est chargée
	const loaded = () => {
		document.addEventListener('DOMContentLoaded', () => {
			document.body.classList.add('loaded');
			bsBreakpoints.init();
		});
	};

	const deleteEmpty = (html) => {
		document.querySelectorAll(html).forEach((el) => {
			const content = el.innerText;
			if (content === null || content === undefined || content === '') {
				el.remove();
			}
		});
	};
	const adaptativeFooter = () => {
		const h = window.innerHeight;
		const main = document.querySelector('main');
		const footerHeight = document.querySelector('.footer')
			? document.querySelector('.footer').offsetHeight - 0.5
			: 0;
		const headerHeight = document.querySelector('header').offsetHeight;
		const sum = footerHeight + headerHeight;
		if (main.offsetHeight < h) {
			main.setAttribute(
				'style',
				'position:relative; min-height:calc(100vh - ' + sum + 'px);'
			);
		}
	};

	const byPassLinks = () => {
		const byPassLinks = document.querySelector('.bypass-links');

		document.addEventListener('keydown', function (e) {
			setTimeout(() => {
				if (document.activeElement.classList.contains('bypass-link')) {
					byPassLinks.classList.remove('visually-hidden');
				} else {
					byPassLinks.classList.add('visually-hidden');
				}
			}, 0);
		});

		const goToAnchor = (link, e) => {
			const anchor =
				document.querySelector(`${link.getAttribute('href')}`) || null;
			const attr = link.getAttribute('href');
			if (attr === '#edit-text') {
				const search = document.querySelector(
					'.header__search input[type="text"]'
				);
				e.preventDefault();
				search.focus();
			} else if (attr === '#block-spe-main-menu') {
				e.preventDefault();
				anchor.querySelector('.first a').focus();
			}
			byPassLinks.classList.add('visually-hidden');
			executed = true;
		};

		byPassLinks.querySelectorAll('a').forEach((link) => {
			link.addEventListener('keydown', function (e) {
				if (e.key === 'Enter') {
					goToAnchor(link, e);
				}
				if (e.key === 'Escape') {
					const focusable = document
						.querySelector('.header')
						.querySelectorAll(
							'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
						);
					console.log(focusable);
					focusable[0].focus();
					byPassLinks.classList.add('visually-hidden');
					executed = true;
				}
			});

			link.addEventListener('click', function (e) {
				goToAnchor(link, e);
			});
		});
	};

	// GO 🚀
	const init = () => {
		loaded();
		deleteEmpty('p');
		deleteEmpty('li');
		adaptativeFooter();
		byPassLinks();
	};

	init();
})();
